import { useToast } from '~/contexts/toast-context';
import styles from './Toast.module.css';

export function ToastContainer() {
  const { toasts } = useToast();

  return (
    <div className={styles.toastContainer}>
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${styles[`toast_${toast.variant || 'success'}`]}`}
        >
          {toast.variant === 'loading' && (
            <div className={styles.spinner} />
          )}
          {toast.variant !== 'loading' && (
            <div className={styles.indicator} />
          )}
          <span className={styles.message}>{toast.title}</span>
        </div>
      ))}
    </div>
  );
}
